<div class="main-content incidencia-report-page">
  <div class="container-fluid">
    <section class="incidencia-report-page__hero" [formGroup]="formRegistro">
      <div class="incidencia-report-page__hero-copy">
        <p class="incidencia-report-page__eyebrow">Incidencias QA</p>
        <h1>Reporte de incidencias</h1>
        <p>Consulta el comportamiento de defectos por versión y resume el ciclo de pruebas.</p>
      </div>

      <div class="incidencia-report-page__hero-meta">
        <div class="incidencia-report-page__hero-tags">
          <span *ngIf="proyectoNombre">Proyecto: <strong>{{ proyectoNombre }}</strong></span>
          <span *ngIf="etapaNombre">Etapa: <strong>{{ etapaNombre }}</strong></span>
        </div>

        <div class="incidencia-report-page__hero-controls">
          <mat-form-field appearance="outline" class="incidencia-report-page__version-field">
            <mat-label>Versión</mat-label>
            <mat-select formControlName="version" (selectionChange)="capturarversion($event.value)">
              <mat-option *ngFor="let opcion of opcionesVersion" [value]="opcion.id">
                {{ opcion.etiqueta }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button type="button" mat-raised-button class="btn app-form-btn app-form-btn--secondary"
            (click)="onCloseClick()">
            Regresar
          </button>
        </div>
      </div>
    </section>

    <section class="incidencia-report-page__layout">
      <div class="incidencia-report-page__main-column">
        <div class="incidencia-report-page__card incidencia-report-page__card--summary">
          <h2>Ciclo de prueba</h2>
          <div class="incidencia-report-page__cycle-grid" [formGroup]="formRegistro">
            <mat-form-field appearance="outline">
              <mat-label>Aprobados</mat-label>
              <input matInput aria-label="Aprobados" type="text" formControlName="cAprobados" maxlength="10" (keyup)="sumarCiclo()" soloNumeroEntero />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Defectos</mat-label>
              <input matInput aria-label="Defectos" type="text" formControlName="cdefetuosos" maxlength="10" (keyup)="sumarCiclo()" soloNumeroEntero />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Pendientes</mat-label>
              <input matInput aria-label="Pendientes" type="text" formControlName="cpendientes" maxlength="10" (keyup)="sumarCiclo()" soloNumeroEntero />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Total ciclos</mat-label>
              <input matInput aria-label="Total ciclos" type="text" formControlName="ctotal" readonly />
            </mat-form-field>
          </div>

          <div class="incidencia-report-page__chart" *ngIf="totalCiclo > 0; else chartPlaceholder">
            <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
              [legend]="barChartLegend"></canvas>
          </div>

          <ng-template #chartPlaceholder>
            <div class="incidencia-report-page__chart-empty">
              <strong>Gráfica pendiente</strong>
              <p>Captura los valores del ciclo de prueba para visualizar el resumen.</p>
            </div>
          </ng-template>

          <div class="incidencia-report-page__stats">
            <div class="incidencia-report-page__stat incidencia-report-page__stat--approved">
              <strong>Aprobados</strong>
              <span>{{ numeroAprobados }}</span>
              <small>{{ (porcentajeAprobados * 100).toFixed(2) }}%</small>
            </div>
            <div class="incidencia-report-page__stat incidencia-report-page__stat--defects">
              <strong>Defectos</strong>
              <span>{{ numeroDefectuosos }}</span>
              <small>{{ (porcentajeDefectuosos * 100).toFixed(2) }}%</small>
            </div>
            <div class="incidencia-report-page__stat incidencia-report-page__stat--pending">
              <strong>Pendientes</strong>
              <span>{{ numeroPendientes }}</span>
              <small>{{ (porcentajePendientes * 100).toFixed(2) }}%</small>
            </div>
          </div>
        </div>

        <div class="incidencia-report-page__card">
          <h2>Defectos por tipo</h2>
          <div class="incidencia-report-page__table-wrap" *ngIf="reporteIncidencia.length; else defectosEmpty">
            <table class="incidencia-report-page__table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th>Conteo</th>
                  <th>Porcentaje</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of reporteIncidencia">
                  <td>{{ row.tipo }}</td>
                  <td>{{ row.contador ? row.contador : 0 }}</td>
                  <td>{{ totalDefectos ? ((row.contador / totalDefectos) * 100).toFixed(2) : '0.00' }}%</td>
                </tr>
                <tr class="incidencia-report-page__table-total">
                  <td>Total</td>
                  <td>{{ totalDefectos }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #defectosEmpty>
            <p class="incidencia-report-page__empty">No hay defectos registrados para la versión seleccionada.</p>
          </ng-template>
        </div>
      </div>

      <aside class="incidencia-report-page__side-column">
        <div class="incidencia-report-page__card incidencia-report-page__card--incidencias">
          <div class="incidencia-report-page__incidencias-header">
            <h2>Histórico de incidencias</h2>
            <span>{{ incidencias.length }} registro(s)</span>
          </div>

          <ul class="incidencia-report-page__incidencias-list">
            <li *ngFor="let row of incidencias">
              <strong>{{ row.titulo }}</strong>
              <p>{{ row.descincidencia }}</p>
            </li>
            <li *ngIf="!incidencias.length" class="incidencia-report-page__empty">Sin incidencias para esta versión.</li>
          </ul>
        </div>
      </aside>
    </section>
  </div>
</div>
